import React, {useEffect, useState} from 'react';
import axios from "axios";
import {getBaseUrl} from "../utils";
import Select from "react-select";
import {useLocation, useNavigate} from 'react-router-dom';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    FaUser,
    FaGraduationCap,
    FaMapMarkerAlt,
    FaFileInvoice,
    FaTrash,
    FaEnvelope,
    FaCalendarAlt,
    FaPhone,
    FaCamera
} from "react-icons/fa";

const ResumeCreate = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const userProfileId = searchParams.get("userProfileId");
    // const [searchParams] = useSearchParams();
    const [educationType, setEducationType] = useState("");

    var templateNumber = searchParams.get("template");
    console.log("templateNumber----->", templateNumber);

    useEffect(() => {
        const fetchProfileData = async () => {
            console.log("userProfileId----fetchProfileData--->", userProfileId);
            if (!userProfileId) return; // Skip if no userProfileId

            try {
                const response = await axios.get(`${baseUrl}user_api/profile?userProfileId=${userProfileId}`, {
                    headers: {Authorization: `Bearer ${token}`},
                });
                if (response.data.status) {
                    const userData = response.data.results;
                    console.log("userData----->", userData);

                    // Extract location data safely
                    var stateName = userData.stateInfo?.name || "";
                    var cityName = userData.cityInfo?.name || "";
                    var pincode = userData.pincodeInfo?.name || "";
                    var stateId = userData.stateInfo?._id || "";
                    var cityId = userData.cityInfo?._id || "";
                    var pincodeId = userData.pincodeInfo?._id || "";


                    // Set data in state
                    setBasicDetails({
                        id: userData._id || '', // Set ID for updating profile
                        name: userData.name || '',
                        template_no: userData.template_no || '',
                        profileSummary: userData.profileSummary || '',
                        email: userData.email || '',
                        gender: userData.gender || '',
                        dob: userData.dob || '',
                        classId: userData.classId || '',
                        profileTagline: userData.profileTagline || '',
                        address: userData.address || '',
                        state: stateName,  // Set state name
                        city: cityName,  // Set city name
                        pincodeName: pincode, // Set pincode
                        stateId: stateId,  // Set state ID
                        cityId: cityId,  // Set city ID
                        pincodeId: pincodeId,  // Set pincode ID
                        number: userData.number || '',
                        profile_img: userData.profile_img || '',
                        template_no: userData.template_no || templateNumber || '',
                    });

                    setWorkExperience(userData.workExperience.length > 0 ?
                        userData.workExperience.map(exp => ({
                            ...exp,
                            currentlyWorking: exp.currentlyWorking ?? !exp.endDate // Ensure it's defined
                        })) : [{
                            skillId: [],
                            candidateType: '',
                            jobResponsibilities: '',
                            jobTitle: '',
                            companyName: '',
                            startDate: '',
                            endDate: '',
                            hobbies: [],
                            languages: [],
                            currentlyWorking: false // Default value
                        }]);


                    setEducationalDetails(userData.educationalDetails.length > 0 ? userData.educationalDetails : [{
                        universityId: '',
                        educationType: '',
                        collegeName: '',
                        courseName: '',
                        percentage_CGPA: '',
                        startMonth: '',
                        endMonth: ''
                    }]);

                } else {
                    console.error("Failed to fetch profile data:", response.data.message);
                }
            } catch (error) {
                console.error("Error fetching profile data:", error.message);
            }
        };

        const checkUserProfileId = async () => {
            if (!userProfileId) {
                try {
                    const response = await axios.get(`${baseUrl}user_api/getProfileData`, {
                        headers: {Authorization: `Bearer ${token}`},
                    });

                    if (response.data.status && response.data.results?._id) {
                        const newProfileId = response.data.results._id;
                        var userData = response.data.results;
                        console.log("Fetched userData Profile", userData);

                        var stateName = userData.stateDetails?.name || "";
                        var cityName = userData.cityDetails?.name || "";
                        var pincode = userData.pincodeDetails?.name || "";
                        var stateId = userData.stateDetails?._id || "";
                        var cityId = userData.cityDetails?._id || "";
                        var pincodeId = userData.pincodeDetails?._id || "";

                        setBasicDetails({
                            name: userData.name || '',
                            email: userData.email || '',
                            gender: userData.gender || '',
                            dob: userData.dob || '',
                            address: userData.address || '',
                            state: stateName,  // Set state name
                            city: cityName,  // Set city name
                            pincodeName: pincode, // Set pincode
                            stateId: stateId,  // Set state ID
                            cityId: cityId,  // Set city ID
                            pincodeId: pincodeId,  // Set pincode ID
                            number: userData.number || '',
                            profile_img: userData.profile_img || '',
                        });
                    } else {
                        console.error("Failed to fetch user profile ID");
                        // Set default values if profile data isn't available
                    }
                } catch (error) {
                    console.error("Error fetching user profile ID:", error.message);
                }
            } else {
                fetchProfileData(userProfileId);
            }
        };

        checkUserProfileId();
    }, [userProfileId]);

    const baseUrl = getBaseUrl();
    const token = localStorage.getItem("userToken");
    // Which section is currently active
    const [HandleResume, setHandleResume] = useState('ResumeOneUpdate');

    // State for basic details
    const [basicDetails, setBasicDetails] = useState({
        id: '', // if needed, prepopulate or leave empty
        name: '',
        profileSummary: '',
        email: '',
        gender: '',
        dob: '',
        classId: '',
        profileTagline: '',
        address: '',
        stateId: '',
        cityId: '',
        pincodeId: '',
        number: '',
        profile_img: null,
        template_no: templateNumber || '',
    });

    // State for work experience (array of objects)
    const [workExperience, setWorkExperience] = useState([
        {
            // If your backend requires skillId as an array, you might later split/combine input values.
            skillId: [],
            candidateType: '',
            jobTitle: '',
            companyName: '',
            startDate: '',
            endDate: '',
            hobbies: [],
            languages: []
        }
    ]);

    console.log('workExperienceworkExperienceworkExperienceworkExperienceworkExperienceworkExperience', workExperience)
    // State for educational details (array of objects)
    const [educationalDetails, setEducationalDetails] = useState([
        {
            universityId: '',
            educationType: '',
            collegeName: '',
            courseName: '',
            percentage_CGPA: '',
            startMonth: '',
            endMonth: ''
        }
    ]);

    // Example sidebar sections (you can adjust icons/labels as needed)
    const SidebarSection = [
        {
            label: 'Basic Details',
            Paragraph: 'Name, Email, Mobile No etc',
            iconsImages: <i className="ri-user-location-fill text-[22px] text-[#D0D0D0]"></i>,
            id: 'ResumeOneUpdate'
        },
        {
            label: 'Educational Details',
            Paragraph: 'Provide your details to create your profile.',
            iconsImages: <i className="ri-user-location-fill text-[22px] text-[#D0D0D0]"></i>,
            id: 'ResumeTowUpdate'
        },
        {
            label: 'Update Resume',
            Paragraph: 'Update your resume with latest information.',
            iconsImages: <i className="ri-edit-box-fill text-[22px] text-[#D0D0D0]"></i>,
            id: 'ResumeThreeUpadate'
        }
    ];
    // Change active section on sidebar click
    const handleSidebarClick = (id) => {
        if (HandleResume !== id) {
            setHandleResume(id);
        }
    };
    // Handler for basic details inputs
    const handleBasicDetailsChange = (e) => {
        const {name, value} = e.target;
        setBasicDetails((prev) => ({
            ...prev,
            [name]: value
        }));

        if (name === "profileTagline") {
            const words = value.trim().split(/\s+/);
            if (words.length > 49) {
                alert("Maximum 50 words allowed for tagline!");
                return;
            }
        }


        if (name === "pincodeName" && value.length == 6) {
            console.log("value------>", value);
            fetchLocationData(value);
        }
    };
    // Handler for work experience inputs
    const handleWorkExperienceChange = (index, e) => {
        const {name, value} = e.target;
        const updatedExp = [...workExperience];
        updatedExp[index][name] = value;
        setWorkExperience(updatedExp);
    };

    const handleCurrentlyWorkingToggle = (index) => {
        console.log("index--->", index);
        setWorkExperience(prevExperience => prevExperience.map((exp, i) =>
            i === index ? {
                ...exp,
                currentlyWorking: !exp.currentlyWorking,
                endDate: exp.currentlyWorking ? '' : exp.endDate
            } : exp
        ));
    };

    // Handler for educational details inputs
    // const handleEducationalDetailsChange = (index, e) => {
    //     const { name, value } = e.target;
    //     const updatedEdu = [...educationalDetails];
    //     updatedEdu[index][name] = value;
    //     setEducationalDetails(updatedEdu);
    //     const boardTypes = ["Primary", "Secondary", "Higher Secondary"];
    //     const isBoardType = boardTypes.includes(updatedEdu?.educationType);
    //     console.log("Education Type:", );
    //     console.log("Is Board Type:", isBoardType);
    // };

    const handleEducationalDetailsChange = (index, e) => {
        const {name, value} = e.target;

        const updatedEdu = [...educationalDetails];
        updatedEdu[index][name] = value;
        setEducationalDetails(updatedEdu);

        const boardTypes = ["Primary", "Secondary", "Higher Secondary"];

        const selectedType = updatedEdu[index]?.educationType;
        const isBoardType = boardTypes.includes(selectedType);

        if (isBoardType) {
            setEducationType("Board");
        } else {
            setEducationType("");
        }

        console.log("Education Type:", selectedType);
        console.log("Is Board Type:", isBoardType);
    };


    // Add another work experience entry
    const addWorkExperience = () => {
        setWorkExperience((prev) => [
            ...prev,
            {
                skillId: [],
                jobTitle: '',
                companyName: '',
                candidateType: '',
                startDate: '',
                endDate: '',
                hobbies: [],
                languages: []
            }
        ]);
    };
    const removeWorkExperience = (index) => {
        setWorkExperience(workExperience.filter((_, i) => i !== index));
    };
    const addEducation = () => {
        setEducationalDetails([...educationalDetails, {
            universityId: '',
            educationType: '',
            collegeName: '',
            courseName: '',
            percentage_CGPA: '',
            startMonth: '',
            endMonth: ''
        }]);
    };
    const removeEducation = (index) => {
        setEducationalDetails(educationalDetails.filter((_, i) => i !== index));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("basicDetails---->", basicDetails);
        console.log("workExperience---->", workExperience);
        console.log("educationalDetails---->", educationalDetails);
        console.log("templateNumber---->", templateNumber);

        const formData = new FormData();

        // Append profile image only if it's a file
        console.log("profile_img----0>", basicDetails.profile_img);

        if (basicDetails.profile_img instanceof File) {
            console.log("profile_img----1>", basicDetails.profile_img);
            formData.append("profile_img", basicDetails.profile_img);
        } else if (typeof basicDetails.profile_img === "string" && basicDetails.profile_img.startsWith("http")) {
            console.log("Fetching file from URL:", basicDetails.profile_img);

            try {
                const response = await fetch(basicDetails.profile_img);
                const blob = await response.blob();
                const fileName = basicDetails.profile_img.split("/").pop(); // Extract file name from URL
                const file = new File([blob], fileName, {type: blob.type});

                console.log("Converted File:", file);
                formData.append("profile_img", file);
            } catch (error) {
                console.error("Error fetching image file:", error);
            }
        }

        if (templateNumber) {
            formData.append("template_no", templateNumber);
        }

        // Append ID if updating
        // if (basicDetails.id) {
        //     formData.append("id", basicDetails.id);
        // }
        // Append basic details
        // for (let key in basicDetails) {
        //     formData.append(key, basicDetails[key]);
        // }
        for (let key in basicDetails) {
            if (key !== "profile_img") {
                formData.append(key, basicDetails[key]);
            }
        }
        // Append arrays as JSON
        if (Array.isArray(workExperience) && workExperience.length > 0) {
            formData.append('workExperience', JSON.stringify(workExperience));
        }
        if (Array.isArray(educationalDetails) && educationalDetails.length > 0) {
            formData.append('educationalDetails', JSON.stringify(educationalDetails));
        }
        for (let pair of formData.entries()) {
            console.log(pair[0], pair[1]);
        }
        const loadingToast = toast.loading("Processing... Please wait");

        try {
            const response = await axios.patch(
                `${baseUrl}user_api/saveUpdateProfile`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Add your token here
                        'Content-Type': 'multipart/form-data', // Required for FormData
                    },
                }
            );
            console.log("API Response:", response.data);
            // toast.dismiss(loadingToast);
            if (response.status === 200) {
                //alert("Profile updated successfully!");
                //      toast.update(loadingToast, {
                //     render: response.data.message || "Profile updated successfully!",
                //     type: "success",
                //     isLoading: false,
                //     autoClose: 3000,
                //     closeOnClick: true,
                //     draggable: true,
                // });
                //         navigate("/dashboard/resume");
                toast.update(loadingToast, {
                    render: response.data.message || "Profile updated successfully!",
                    type: "success",
                    isLoading: false,
                    autoClose: 2000, // 2 sec
                });

                setTimeout(() => {
                    navigate("/dashboard/resume");
                }, 2000); // wait for toast to finish

            } else {
                toast.update(loadingToast, {
                    render: response.data.message || "Something went wrong!",
                    type: "error",
                    isLoading: false,
                    autoClose: 3000,
                });
            }
        } catch (error) {
            toast.update(loadingToast, {
                render: "Error updating profile.",
                type: "error",
                isLoading: false,
                autoClose: 3000,
            });
            console.error("Error in API call:", error);
        }
    };
    const fetchLocationData = async (pincodeName) => {
        try {
            const response = await axios.get(`${baseUrl}user_api/locationList?pincodeName=${pincodeName}`, {
                headers: {Authorization: `Bearer ${token}`},
            });
            if (response.data.status && response.data.results.length > 0) {
                const location = response.data.results[0];
                setBasicDetails((prevState) => ({
                    ...prevState,
                    state: location.stateInfo[0]?.name || "",
                    city: location.cityInfo[0]?.name || "",
                    stateId: location.stateInfo[0]?._id || "",
                    cityId: location.cityInfo[0]?._id || "",
                    pincodeId: location._id || "",
                }));
            } else {
                setBasicDetails((prevState) => ({
                    ...prevState,
                    state: "",
                    city: "",
                    stateId: "",
                    cityId: "",
                    pincodeId: "",
                }));
                alert("No location data found for the provided pincode.");
            }
        } catch (error) {
            console.error("Error fetching location data:", error.message);
        }
    };
    // const GetTypeData = 
    const [universities, setUniversities] = useState([]);
    console.log('universitiesuniversitiesuniversities', universities)
    useEffect(() => {
        const fetchUniversities = async () => {
            try {
                const response = await axios.get(
                    `${baseUrl}user_api/universityList?type=${educationType}`,
                    {
                        headers: {Authorization: `Bearer ${token}`},
                    }
                );

                if (response.data.status && response.data.results.length > 0) {
                    setUniversities(response.data.results);
                } else {
                    setUniversities([]);
                }
            } catch (error) {
                console.error("Error fetching universities:", error.message);
            }
        };

        fetchUniversities();
    }, [educationType]); // 👈 jab board aaye tabhi change ho

    const [skills, setSkills] = useState([]);
    useEffect(() => {
        const fetchSkills = async () => {
            try {
                const response = await axios.get(`${baseUrl}user_api/skillList`, {
                    headers: {Authorization: `Bearer ${token}`},
                });

                if (response.data.status && response.data.results.length > 0) {
                    setSkills(response.data.results);
                } else {
                    setSkills([]); // Clear list if no data
                    console.error("No skills found.");
                }
            } catch (error) {
                console.error("Error fetching skills:", error.message);
            }
        };

        fetchSkills();
    }, []);
    const [languages, setLanguages] = useState([]);
    useEffect(() => {
        const fetchLanguage = async () => {
            try {
                const response = await axios.get(`${baseUrl}user_api/languageList`, {
                    headers: {Authorization: `Bearer ${token}`},
                });
                if (response.data.status && response.data.results.length > 0) {
                    setLanguages(response.data.results);
                } else {
                    setLanguages([]); // Clear list if no data
                    console.error("No languages found.");
                }
            } catch (error) {
                console.error("Error fetching languages:", error.message);
            }
        };
        fetchLanguage();
    }, []);

    const [hobbys, setHobbys] = useState([]);
    useEffect(() => {
        const fetchHobbys = async () => {
            try {
                const response = await axios.get(`${baseUrl}user_api/hobbyList`, {
                    headers: {Authorization: `Bearer ${token}`},
                });
                if (response.data.status && response.data.results.length > 0) {
                    setHobbys(response.data.results);
                } else {
                    setHobbys([]);
                    console.error("No hobbys found.");
                }
            } catch (error) {
                console.error("Error fetching hobbys:", error.message);
            }
        };
        fetchHobbys();
    }, []);
    const handleSelectChange = (index, selectedOptions, field) => {
        // const selectedValues = selectedOptions.map(option => option.value);
        const selectedValues = (selectedOptions || []).map(option => option.value);
        setWorkExperience(prev => {
            const updatedExp = [...prev];
            updatedExp[index][field] = selectedValues;
            return updatedExp;
        });
    };

    const selectStyles = {
        control: (provided) => ({
            ...provided,
            border: "none",
            boxShadow: "none",
            backgroundColor: "white",
            minHeight: "50px",
            display: "flex",
            alignItems: "start",
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#f0f0f0",
            display: "flex",
            alignItems: "start",
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            display: "block",
        }),
        indicatorsContainer: () => ({
            display: "flex",
            position: "relative",
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: "#000",
            cursor: "pointer",
            ":hover": {
                backgroundColor: "#e0e0e0",
                color: "#333",
            },
        }),
    };

    const defaultWorkExperience = {
        skillId: [],
        candidateType: '',
        jobTitle: '',
        companyName: '',
        startDate: '',
        endDate: '',
        hobbies: [],
        languages: [],
        currentlyWorking: false
    };

    const primaryExperience = workExperience[0] || defaultWorkExperience;

    const handlePrimarySelectChange = (selectedOptions, field) => {
        const selectedValues = (selectedOptions || []).map(option => option.value);

        setWorkExperience((prev) => {
            const updatedExp = prev.length ? [...prev] : [{...defaultWorkExperience}];
            updatedExp[0] = {
                ...updatedExp[0],
                [field]: selectedValues
            };
            return updatedExp;
        });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setBasicDetails({...basicDetails, profile_img: file}); // Store file, not URL
        }
    };
    console.log("basicDetails---->", basicDetails);

    const getPlaceholdersByEducationType = (educationType) => {
        switch (educationType) {
            case "Primary":
            case "Secondary":
            case "Higher Secondary":
                return ["School Name", "Board Name"];

            case "Diploma":
                return ["Institute Name", "University Name"];

            case "Undergraduate":
            case "Graduation":
                return ["College Name", " University Name"];

            case "Postgraduate":
                return ["College Name", " University Name"];

            case "Doctorate (PhD)":
                return ["College Name", "University / Research Institute"];

            case "Certification":
            case "Vocational":
                return ["University Name", "Institute / Training Center Name"];

            case "Other":
                return ["Institute Name", "University Name"];

            default:
                return ["College Name", "University Name"];
        }
    };

    const getNextMonth = (month) => {
        if (!month) return "";

        let [year, mon] = month.split("-").map(Number);

        mon += 1;
        if (mon > 12) {
            mon = 1;
            year += 1;
        }

        return `${year}-${String(mon).padStart(2, "0")}`;
    };

    return (
        <>
            <ToastContainer/>

            <form onSubmit={handleSubmit}>
                <div className="container-fluid">
                    <div className="row">
                        <h6 className="text-gray-600 Paragraph__etxt">
                            My Resume <span className="text-black font-bold">Create Resume</span>
                        </h6>
                        <div className="col-lg-4">
                            <div className="bg-white p-4 rounded-xl mt-3">
                                {SidebarSection.map((section) => (
                                    <div
                                        className={`h-full cursor-pointer ${HandleResume === section.id ? 'active' : ''}`}
                                        key={section.id}
                                        onClick={() => handleSidebarClick(section.id)}
                                    >
                                        <div className="flex gap-2">
                                            <div className="flex flex-col items-center">
                                                <div
                                                    className={`bg-[#F4F4F4] mb-9 w-[50px] h-[50px] flex items-center justify-center rounded-[10px] ${HandleResume === section.id ? 'bg-[#D0D0D0]' : ''
                                                    }`}
                                                >
                                                    {section.iconsImages}
                                                </div>
                                            </div>
                                            <div>
                                                <h4 className={`font-[700] Paragraph__etxt ${HandleResume === section.id ? 'text-black' : 'text-gray-600'}`}>
                                                    {section.label}
                                                </h4>
                                                <p className="Paragraph__etxt font-[300]">{section.Paragraph}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-lg-8 pt-3">
                            {/* Basic Details Section */}
                            {HandleResume === 'ResumeOneUpdate' && (
                                <div>
                                    <h1 className="Header__text font-bold" style={{fontSize: '18px'}}>
                                        Fill your basic details.
                                    </h1>

                                    <div
                                        className="relative w-full rounded-full flex items-center justify-center overflow-hidden">
                                        <div className="w-full flex items-center justify-center">
                                            <div className="relative">
                                                {/* Profile Image */}
                                                <div
                                                    className="rounded-full w-[100px] border bg-red-500 h-[100px] overflow-hidden">
                                                    {basicDetails.profile_img ? (
                                                        <img
                                                            src={
                                                                basicDetails.profile_img instanceof File
                                                                    ? URL.createObjectURL(basicDetails.profile_img)
                                                                    : basicDetails.profile_img.replace(/\\/g, "/") // Replace backslashes
                                                            }
                                                            alt="Profile Preview"
                                                            className="w-full h-full object-cover"
                                                        />
                                                    ) : (
                                                        <FaUser className="text-4xl text-gray-600"/>
                                                    )}
                                                </div>
                                                {/* Camera Icon */}
                                                <div
                                                    className="absolute bottom-0 right-0 bg-black bg-opacity-50 p-2 rounded-full cursor-pointer flex items-center justify-center">
                                                    <label className="cursor-pointer">
                                                        <FaCamera className="text-white text-sm"/>
                                                        <input
                                                            type="file"
                                                            className="hidden"
                                                            accept="image/*"
                                                            onChange={handleFileChange}
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex justify-between gap-[20px] mt-4">
                                        <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                            <div className="w-full pl-2 pr-2">
                                                <input
                                                    type="text"
                                                    name="name"
                                                    value={basicDetails.name}
                                                    onChange={handleBasicDetailsChange}
                                                    required
                                                    placeholder="Full Name"
                                                    className="w-full pt-3 pb-3"
                                                    style={{outline: 'none'}}
                                                />
                                            </div>
                                        </div>
                                        <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                            <div className="w-full pl-2 pr-2">
                                                <input
                                                    type="email"
                                                    name="email"
                                                    required
                                                    value={basicDetails.email}
                                                    onChange={handleBasicDetailsChange}
                                                    placeholder="Email Address"
                                                    className="w-full pt-3 pb-3"
                                                    style={{
                                                        outline: "none",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex justify-between gap-[20px] mt-4">
                                        {/* <div className="bg-[#FFFFFF] w-[150px] rounded-[15px] flex items-center justify-center">
                                            +91
                                        </div> */}
                                        <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                            <div className="w-full pl-2 pr-2">
                                                <input
                                                    type="number"
                                                    name="number"
                                                    value={basicDetails.number}
                                                    onChange={handleBasicDetailsChange}
                                                    required
                                                    placeholder="Enter your mobile number"
                                                    className="w-full pt-3 pb-3"
                                                    style={{
                                                        outline: "none",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                            <div className="w-full pl-2 pr-2">
                                                <input
                                                    type="text"
                                                    name="dob"
                                                    value={basicDetails.dob}
                                                    onChange={handleBasicDetailsChange}
                                                    required
                                                    placeholder="DOB (YYYY-MM-DD)"
                                                    className="w-full"
                                                    style={{
                                                        outline: "none",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex justify-between gap-[20px] mt-4">
                                        <div
                                            className="flex bg-[#FFFFFF] rounded-lg w-full rounded-[10px] items-center">
                                            <div className="w-full rounded-lg">
                                                <select
                                                    required
                                                    placeholder="Choose Gender"
                                                    className="w-full p-3 rounded-lg"
                                                    style={{
                                                        outline: "none",
                                                    }}
                                                    name='gender'
                                                    value={basicDetails.gender}
                                                    onChange={handleBasicDetailsChange}
                                                >
                                                    <option
                                                        value="Female"
                                                    >
                                                        Female
                                                    </option>
                                                    <option value="Male">
                                                        Male
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                            <div className="w-full pl-2 pr-2">
                                                <input
                                                    type="text"
                                                    name="pincodeName"
                                                    required
                                                    placeholder="Pin Code"
                                                    className="w-full pt-3 pb-3"
                                                    onChange={handleBasicDetailsChange}
                                                    style={{
                                                        outline: "none",
                                                    }}
                                                    value={basicDetails.pincodeName}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex justify-between gap-[20px] mt-4">
                                        <div className="flex bg-[#FFFFFF] w-full rounded-[10px] items-center">
                                            <div className="w-full">
                                                <input
                                                    type="text"
                                                    name="City"
                                                    required
                                                    placeholder="City"
                                                    className="w-full p-3 rounded-lg"
                                                    style={{
                                                        outline: "none",
                                                    }}
                                                    value={basicDetails.city}
                                                />
                                            </div>
                                        </div>
                                        <div className="flex bg-[#FFFFFF] w-full rounded-[10px] items-center">
                                            <div className="w-full ">
                                                <div className="w-full pl-2 pr-2">
                                                    <input
                                                        type="text"
                                                        name="State"
                                                        required
                                                        placeholder="State"
                                                        className="w-full p-3 rounded-lg"
                                                        style={{
                                                            outline: "none",
                                                        }}
                                                        value={basicDetails.state}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex justify-between gap-[20px] mt-4">
                                        <div className="flex bg-[#FFFFFF] w-full rounded-[10px] items-center">
                                            <div className="w-full">
                                                <select
                                                    required
                                                    placeholder="Choose Gender"
                                                    className="w-full p-3 rounded-lg"
                                                    style={{
                                                        outline: "none",
                                                    }}
                                                >
                                                    <option
                                                        value=""
                                                        disabled
                                                    >
                                                        Choose Country
                                                    </option>
                                                    <option value="Male">
                                                        India
                                                    </option>

                                                </select>
                                            </div>
                                        </div>
                                        <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                            <div className="w-full pl-2 pr-2">
                                                <input
                                                    type="text"
                                                    name="address"
                                                    required
                                                    value={basicDetails.address}
                                                    onChange={handleBasicDetailsChange}
                                                    placeholder="Complete Address"
                                                    className="w-full pt-3 pb-3"
                                                    style={{
                                                        outline: "none",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex justify-between gap-[20px] mt-4">
                                        <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                            <div className="w-full pl-2 pr-2">
                                                <textarea
                                                    name="profileTagline"
                                                    value={basicDetails.profileTagline}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const wordCount = value.trim().split(/\s+/).filter(Boolean).length;

                                                        if (wordCount <= 5) {
                                                            handleBasicDetailsChange(e);
                                                        }
                                                    }}
                                                    required
                                                    placeholder="Type Your profile Tagline (max 5 words)"
                                                    className="w-full pt-3 pb-3"
                                                    style={{outline: "none"}}
                                                />
                                            </div>
                                        </div>

                                        <div className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                            <div className="w-full pl-2 pr-2">
                                                <textarea
                                                    name="profileSummary"
                                                    value={basicDetails.profileSummary}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        const wordCount = value.trim().split(/\s+/).filter(Boolean).length;

                                                        if (wordCount <= 49) {
                                                            handleBasicDetailsChange(e);
                                                        }
                                                    }}
                                                    required
                                                    placeholder="Type Your profile Summary (max 50 words)"
                                                    className="w-full pt-3 pb-3"
                                                    style={{outline: "none"}}
                                                />
                                            </div>
                                        </div>
                                    </div>


                                    <div className="flex justify-between gap-[20px] mt-4">
                                        <div className="flex bg-[#FFFFFF] w-[50%] rounded-[10px]">
                                            <div className="flex w-full justify-between gap-[20px]">
                                                <Select
                                                    isMulti
                                                    placeholder="Skills"
                                                    className="w-full rounded-lg"
                                                    styles={selectStyles}
                                                    options={skills.map((skill) => ({
                                                        label: skill.skill_name,
                                                        value: skill._id
                                                    }))}
                                                    value={skills
                                                        .filter((skill) => (primaryExperience.skillId || []).includes(skill._id))
                                                        .map((skill) => ({label: skill.skill_name, value: skill._id}))}
                                                    onChange={(selected) => handlePrimarySelectChange(selected, 'skillId')}
                                                />
                                            </div>
                                        </div>

                                        <div className="flex bg-[#FFFFFF] w-[50%] rounded-[10px] items-center">
                                            <div className="flex w-full justify-between gap-[20px]">
                                                <Select
                                                    isMulti
                                                    placeholder="Hobbies"
                                                    className="w-full rounded-lg"
                                                    styles={selectStyles}
                                                    options={hobbys.map((ho) => ({
                                                        label: ho.hobby_name,
                                                        value: ho._id
                                                    }))}
                                                    value={hobbys
                                                        .filter((ho) => (primaryExperience.hobbies || []).includes(ho._id))
                                                        .map((ho) => ({label: ho.hobby_name, value: ho._id}))}
                                                    onChange={(selected) => handlePrimarySelectChange(selected, 'hobbies')}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex justify-between gap-[20px] mt-4">
                                        <div className="flex bg-[#FFFFFF]  w-full  rounded-[10px] items-center">
                                            <div className="flex w-full justify-between gap-[20px]">
                                                <Select
                                                    className="w-full rounded-lg"
                                                    placeholder="Languages"
                                                    styles={selectStyles}
                                                    isMulti
                                                    options={languages.map(lan => ({
                                                        label: lan.language_name,
                                                        value: lan._id
                                                    }))}
                                                    value={languages
                                                        .filter(lan => (primaryExperience.languages || []).includes(lan._id))
                                                        .map(lan => ({label: lan.language_name, value: lan._id}))}
                                                    onChange={(selected) => handlePrimarySelectChange(selected, 'languages')}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Additional basic details inputs can be added similarly */}
                                    <button
                                        type="button"
                                        onClick={() => setHandleResume('ResumeTowUpdate')}
                                        className="bg-black pl-16 float-right mt-4 rounded-lg text-white pr-16 pt-2 pb-2"
                                    >
                                        Save & Next
                                    </button>
                                </div>
                            )}
                            {/* Educational Details Section */}
                            {HandleResume === 'ResumeTowUpdate' && (
                                <div>
                                    <h1 className="Header__text font-bold" style={{fontSize: '18px'}}>
                                        Fill your educational details.
                                    </h1>
                                    {educationalDetails.map((edu, index) => (
                                        <div key={index} className="border p-3 mb-3">
                                            <div className="flex justify-between gap-[20px]">
                                                <div className='w-full flex flex-col gap-[2px]'>
                                                    <label className='Header__text !text-[14px]'>Education
                                                        Details</label>
                                                    <div
                                                        className="flex bg-[#FFFFFF] h-[50px] px-2 w-full rounded-[10px] items-center">
                                                        <div className="w-full">
                                                            <select
                                                                required
                                                                className="w-full rounded-lg"
                                                                style={{outline: "none"}}
                                                                name="educationType"
                                                                value={edu.educationType}
                                                                onChange={(e) => handleEducationalDetailsChange(index, e)}>
                                                                <option value="" disabled>Choose Education Type</option>
                                                                <option value="Primary">Primary</option>
                                                                <option value="Secondary">Secondary</option>
                                                                <option value="Higher Secondary">Higher Secondary
                                                                </option>
                                                                <option value="Diploma">Diploma</option>
                                                                <option value="Undergraduate">Undergraduate</option>
                                                                <option value="Postgraduate">Postgraduate</option>
                                                                <option value="Graduation">Graduation</option>
                                                                <option value="Doctorate (PhD)">Doctorate (PhD)</option>
                                                                <option value="Certification">Certification</option>
                                                                <option value="Vocational">Vocational</option>
                                                                <option value="Other">Other</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='w-full flex flex-col gap-[2px]'>
                                                    <label
                                                        className='Header__text !text-[14px]'>{getPlaceholdersByEducationType(edu.educationType)[0]}</label>

                                                    <div
                                                        className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                        <div className="w-full pl-2 pr-2 h-[50px]">
                                                            <input
                                                                type="text"
                                                                required
                                                                placeholder={getPlaceholdersByEducationType(edu.educationType)[0]}
                                                                className="w-full pt-3 pb-3 h-[50px]"
                                                                style={{outline: "none"}}
                                                                name="collegeName"
                                                                value={edu.collegeName}
                                                                onChange={(e) => handleEducationalDetailsChange(index, e)}
                                                            />

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="flex justify-between gap-[20px] mt-4">
                                                <div className='w-full flex flex-col gap-[2px]'>
                                                    <label
                                                        className='Header__text !text-[14px]'>{getPlaceholdersByEducationType(edu.educationType)[1]}</label>
                                                    <div
                                                        className="flex bg-[#FFFFFF] w-full rounded-[10px] items-center">
                                                        <div className="w-full">
                                                            <input
                                                                list={`universities-${index}`}
                                                                placeholder={getPlaceholdersByEducationType(edu.educationType)[1]}
                                                                className="w-full p-3 rounded-lg"
                                                                style={{outline: "none"}}
                                                                name="universityName"
                                                                value={
                                                                    edu.universityName ||
                                                                    universities.find((u) => u._id === edu.universityId)?.name ||
                                                                    ""
                                                                }
                                                                onChange={(e) => {
                                                                    const typedValue = e.target.value;
                                                                    const selectedUni = universities.find((u) => u.name === typedValue);

                                                                    if (selectedUni) {
                                                                        // valid selection → save both ID & name
                                                                        handleEducationalDetailsChange(index, {
                                                                            target: {
                                                                                name: "universityId",
                                                                                value: selectedUni._id
                                                                            },
                                                                        });
                                                                        handleEducationalDetailsChange(index, {
                                                                            target: {
                                                                                name: "universityName",
                                                                                value: selectedUni.name
                                                                            },
                                                                        });
                                                                    } else {
                                                                        // typing → update only display text, clear ID
                                                                        handleEducationalDetailsChange(index, {
                                                                            target: {
                                                                                name: "universityName",
                                                                                value: typedValue
                                                                            },
                                                                        });
                                                                        handleEducationalDetailsChange(index, {
                                                                            target: {name: "universityId", value: ""},
                                                                        });
                                                                    }
                                                                }}
                                                                required
                                                            />
                                                            <datalist id={`universities-${index}`}>
                                                                {universities.map((university) => (
                                                                    <option key={university._id}
                                                                            value={university.name}/>
                                                                ))}
                                                            </datalist>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className='w-full flex flex-col gap-[2px]'>
                                                    <label className='Header__text !text-[14px]'>Course Name</label>
                                                    <div
                                                        className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                        <div className="w-full pl-2 pr-2">
                                                            <input
                                                                type="text"
                                                                required
                                                                placeholder="Course Name"
                                                                className="w-full pt-3 pb-3"
                                                                style={{
                                                                    outline: "none",
                                                                }}
                                                                name="courseName"
                                                                value={edu.courseName}
                                                                onChange={(e) => handleEducationalDetailsChange(index, e)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="flex justify-between gap-[20px] mt-4">
                                                <div className='w-full flex flex-col gap-[2px]'>
                                                    <label className='Header__text !text-[14px]'>Percentage /
                                                        CGPA</label>
                                                    <div
                                                        className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                        <div className="w-full pl-2 pr-2">
                                                            <input
                                                                type="text"
                                                                required
                                                                placeholder="Percentage / CGPA"
                                                                className="w-full pt-3 pb-3"
                                                                style={{
                                                                    outline: "none",
                                                                }}
                                                                name="percentage_CGPA"
                                                                value={edu.percentage_CGPA}
                                                                onChange={(e) => handleEducationalDetailsChange(index, e)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='w-full flex flex-col gap-[2px]'>
                                                    <label className='Header__text !text-[14px]'>Start Date</label>

                                                    <div
                                                        className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                        <div className='w-full '>
                                                            <label className='!text-[14px]'>Start Month</label>
                                                        </div>
                                                        <div className="w-full pl-2 pr-2">
                                                            <input
                                                                type="month"
                                                                required
                                                                placeholder="Start Year"
                                                                className="w-full pt-3 pb-3 text-start mr-6"
                                                                style={{
                                                                    outline: "none",
                                                                }}
                                                                name="startMonth"
                                                                value={edu.startMonth}
                                                                onChange={(e) => handleEducationalDetailsChange(index, e)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex justify-between gap-[20px] mt-4">
                                                <div className='w-full flex flex-col gap-[2px]'>
                                                    <label className='Header__text !text-[14px]'>End Date</label>
                                                    <div
                                                        className="flex bg-[#FFFFFF] pl-3 w-[75%] rounded-[10px] items-center">
                                                        <div className='w-full '>
                                                            <label className='!text-[14px]'>End Month</label>
                                                        </div>
                                                        <div className="w-full pl-2 pr-2">
                                                            <input
                                                                type="month"
                                                                required
                                                                placeholder="End Year"
                                                                className="w-full pt-3 pb-3 text-start mr-6"
                                                                style={{
                                                                    outline: "none",
                                                                }}
                                                                name="endMonth"
                                                                value={edu.endMonth}
                                                                min={getNextMonth(edu.startMonth)}
                                                                onChange={(e) => handleEducationalDetailsChange(index, e)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex pl-3 w-[48%]  items-center">
                                                    <button type="button" onClick={() => removeEducation(index)}
                                                            className="bg-red-500 text-white rounded p-2">Remove
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <button type="button" onClick={addEducation}
                                            className="bg-gray-500 text-white pl-16 mt-4 rounded-lg text-white pr-16 pt-2 pb-2 ">Add
                                        More Education
                                    </button>
                                    {/* Add more educational inputs as needed */}
                                    <button
                                        type="button"
                                        onClick={() => setHandleResume('ResumeThreeUpadate')}
                                        className="bg-black pl-16 float-right mt-4 rounded-lg text-white pr-16 pt-2 pb-2"
                                    >
                                        Save & Next
                                    </button>
                                </div>
                            )}
                            {/* Work Experience and Skills Section */}
                            {HandleResume === 'ResumeThreeUpadate' && (
                                <div>
                                    <h1 className="Header__text font-bold" style={{fontSize: '18px'}}>
                                        Fill your work experience and skills.
                                    </h1>
                                    {workExperience.map((exp, index) => (
                                        <div key={index} className="border rounded-lg p-3 mb-3">
                                            <div className="flex justify-between gap-[20px] mt-4">
                                                <div
                                                    className="flex bg-[#FFFFFF] px-2 w-full rounded-[10px] items-center">
                                                    <div className="w-full">
                                                        <select
                                                            required
                                                            className="w-full p-1 rounded-lg"
                                                            style={{outline: "none"}}
                                                            name="candidateType"
                                                            value={exp.candidateType}
                                                            onChange={(e) => handleWorkExperienceChange(index, e)}
                                                        >
                                                            <option value="" disabled>Candidate Type</option>
                                                            <option value="Fresher">Fresher</option>
                                                            <option value="Experienced">Experienced</option>
                                                            <option value="Intern">Intern</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div
                                                    className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                    <div className="w-full  pr-2">
                                                        <input
                                                            type="text"
                                                            name="jobTitle"
                                                            value={exp.jobTitle}
                                                            onChange={(e) => handleWorkExperienceChange(index, e)}
                                                            required={exp.candidateType !== "Fresher"}
                                                            placeholder="Job Title"
                                                            className="w-full pt-3 pb-3"
                                                            style={{
                                                                outline: "none",
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div
                                                    className="flex bg-[#FFFFFF] pl-3 w-full rounded-[10px] items-center">
                                                    <div className="w-full  pr-2">
                                                        <input
                                                            type="text"
                                                            name="companyName"
                                                            value={exp.companyName}
                                                            onChange={(e) => handleWorkExperienceChange(index, e)}
                                                            required={exp.candidateType !== "Fresher"}
                                                            placeholder="Company Name"
                                                            className="w-full pt-3 pb-3"
                                                            style={{
                                                                outline: "none",
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-4">
                                                <div className="bg-[#FFFFFF] rounded-[10px] p-3">
        <textarea
            name="jobResponsibilities"
            value={exp.jobResponsibilities || ""}
            onChange={(e) => handleWorkExperienceChange(index, e)}
            required={exp.candidateType !== "Fresher"}
            placeholder="Job Responsibilities"
            rows={4}
            className="w-full resize-none"
            style={{
                outline: "none",
                border: "none",
            }}
        />
                                                </div>
                                            </div>
                                            <div className="md:flex justify-between gap-[20px] mt-4">
                                                <div
                                                    className="flex bg-[#FFFFFF] w-full pl-2 rounded-[10px] items-center">
                                                    <div className='w-full '>
                                                        <label className='!text-[14px] mr-1'>Start </label>
                                                    </div>
                                                    <div className="w-full pr-2">

                                                        <input
                                                            type="month"
                                                            name="startDate"
                                                            value={exp.startDate}
                                                            onChange={(e) => handleWorkExperienceChange(index, e)}
                                                            required={exp.candidateType !== "Fresher"}
                                                            placeholder="Job Title"
                                                            className="w-full pt-3 pb-3"
                                                            style={{
                                                                outline: "none",
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                {!exp.currentlyWorking && (
                                                    <div
                                                        className="flex md:mt-0 mt-6 bg-[#FFFFFF] pl-2 w-full rounded-[10px] items-center">
                                                        <div className='w-full '>
                                                            <label className='!text-[14px] mr-1'>End </label>
                                                        </div>
                                                        <div className="w-full pr-2">
                                                            <input
                                                                type="month"
                                                                name="endDate"
                                                                value={exp.endDate}
                                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                                required={exp.candidateType !== "Fresher"}
                                                                placeholder="Job Title"
                                                                className="w-full pt-3 pb-3"
                                                                min={getNextMonth(exp.startDate)}
                                                                style={{
                                                                    outline: "none",
                                                                    border: 'none',

                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                                <div
                                                    className="flex md:mt-0 mt-6 bg-[#FFFFFF] w-full pl-2 rounded-[10px] items-center">
                                                    <div className="flex mt-2">
                                                        <input
                                                            type="checkbox"
                                                            checked={exp.currentlyWorking}
                                                            onChange={() => handleCurrentlyWorkingToggle(index)}
                                                        />
                                                        <label className="ml-2">Currently Working</label>
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="flex justify-between gap-[20px] mt-4">
                                                <div
                                                    className="flex  w-full rounded-[10px] items-center justify-between">
                                                    <button type="button" onClick={() => removeWorkExperience(index)}
                                                            className="bg-red-500 text-white rounded p-2">Remove
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <button
                                        type="button"
                                        onClick={addWorkExperience}
                                        className="bg-gray-500 text-white rounded p-2"
                                    >
                                        Add More Experience
                                    </button>
                                    <button type="submit"
                                            className="bg-black pl-16 float-right mt-4 rounded-lg text-white pr-16 pt-2 pb-2">
                                        Submit Now
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </form>
        </>

    );
};

export default ResumeCreate;
